import loader from 'scriptjs';


export default class DependencyManager {

	static load(base, modules) {
		loader(base, 'base');
		loader.ready('base', () => DependencyManager.loadModules(modules));
	}

	/**
	 * @param {Array<String|Array<String>>} dependencies
	 * @return {String}
	 */
	static loadDependencies(dependencies) {
		const priority =  dependencies.filter(d => Array.isArray(d));
		const priorityId = DependencyManager.uniqueId();

		const standard = dependencies.filter(d => !Array.isArray(d));
		const standardId = DependencyManager.uniqueId();

		if (priority.length) {
			loader(priority, priorityId);
			loader.ready(priorityId, () => loader(standard, standardId));
		} else {
			loader(standard, standardId);
		}
		return standardId;
	}

	/**
	 *
	 * @param {Array<AutoLoadModule>} modules
	 */
	static loadModules(modules) {
		modules.forEach(DependencyManager.loadModule);
	}

	/**
	 * @param {Object<AutoLoadModule>} module
	 */
	static loadModule(module) {
		const holders = module.getHolderSelectors().flatMap(selector => [...document.querySelectorAll(selector)]);
		if (!holders.length) return;
		if (module.getDependencies().length) {
			loader.ready(DependencyManager.loadDependencies(module.getDependencies()),
				() => DependencyManager.initModule(holders, module));
		} else {
			DependencyManager.initModule(holders, module);
		}
	}

	static uniqueId() {
		return "id-" + Math.random().toString(16).slice(2);
	}

	static initModule(holderElements, module) {
		holderElements.forEach((holderElement)  => new module(holderElement))
	}


}




